"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var activeStyles = (0, _styledComponents.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  visibility: visible;\n  opacity: 1;\n"])));

var StyledWrapper = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  overflow: hidden;\n  position: absolute;\n  z-index: 2;\n  top: 0;\n  left: 0;\n  background: white;\n  height: 100%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.875rem;\n\n  visibility: hidden;\n  opacity: 0;\n\n  ", ";\n\n  transition-property: visibility, opacity;\n  transition-duration: 0.25s;\n"])), function (p) {
  return p.isActive && activeStyles;
});

var slide = (0, _styledComponents.keyframes)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  0% { transform: translate(-50%, -50%) scale(0.5);}\n  50% { transform: translate(-50%, -50%) scale(1);; }\n  100% { transform: translate(-50%, -50%) scale(0.5);; }\n"])));

var StyledContent = _styledComponents.default.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%) scale(0.5);\n  transform-origin: 50% 50%;\n  animation: ", " linear 3 1.05s;\n"])), slide);

var Wrapper = function Wrapper(_ref) {
  var children = _ref.children,
      isActive = _ref.isActive,
      onAnimationEnd = _ref.onAnimationEnd;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledWrapper, {
    isActive: isActive,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledContent, {
      onAnimationEnd: onAnimationEnd,
      children: children
    })
  });
};

var _default = Wrapper;
exports.default = _default;